import { render, staticRenderFns } from "./main-view.vue?vue&type=template&id=c7d5d216"
import script from "./main-view.vue?vue&type=script&lang=js"
export * from "./main-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports